export { default as formatGLSLCompilerError, parseGLSLCompilerError } from './format-glsl-error';
export { default as getShaderName } from './get-shader-name';
export { default as getShaderVersion } from './get-shader-version';
export { default as getShaderTypeName } from './get-shader-type-name';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@luma.gl/webgl/dist/esm/glsl-utils/index.js